<template>
  <transition
    v-if="imageUrls.length && imageUrlsToDisplay"
    name="fade"
    mode="out-in"
  >
    <div :key="imageUrlsToDisplay[0]" class="random-image">
      <img
        :key="imageUrlsToDisplay[0]"
        class="main-image"
        :src="getImageUrlWithWidth(imageUrlsToDisplay[0])"
        alt=""
      />
      <div v-if="imageUrlsToDisplay.length > 1" class="additional-images">
        <img
          v-for="image in imageUrlsToDisplay.slice(1)"
          :key="image"
          :src="getImageUrlWithWidth(image)"
          alt=""
        />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import sample from 'lodash.sample';
import { ref, onMounted, onUnmounted, computed } from 'vue';

const props = defineProps<{
  imageUrls: string[];
  width?: string;
  intervalTime?: number;
}>();

const imageUrlsToDisplay = ref();
let nextImageUrls: string | undefined;
let interval: ReturnType<typeof setInterval>;

const imageUrlsNotDisplayed = computed(() =>
  props.imageUrls.filter((imageUrl) => imageUrlsToDisplay.value !== imageUrl),
);

const getImageUrlWithWidth = (imageUrl: string) =>
  `${imageUrl}${props.width ? `,width=${props.width},height=${props.width}` : ''}`;

const chooseInitialDisplayedProducts = () => {
  chooseNextImage();

  interval = setInterval(() => {
    chooseNextImage();
  }, props.intervalTime || 3000);
};

const chooseNextImage = () => {
  imageUrlsToDisplay.value = nextImageUrls || sample(props.imageUrls);

  if ((nextImageUrls = sample(imageUrlsNotDisplayed.value))) {
    const image = new Image();
    image.src = getImageUrlWithWidth(nextImageUrls);
  }
};

onMounted(() => {
  chooseInitialDisplayedProducts();
});

onUnmounted(() => {
  clearInterval(interval);
});
</script>

<style lang="scss" scoped>
.random-image {
  display: flex;
  flex-direction: column;
  height: 100%;

  .main-image {
    flex-grow: 1;
    min-height: 0;
    object-fit: contain;
  }

  .additional-images {
    display: flex;
    justify-content: center;
    gap: 16px;

    img {
      width: 100px;
    }
  }
}
</style>
